import { css } from "@emotion/react";

export const indexWrapCss = css`
    padding: 0 0;
    margin: 0 auto;
    display: flex;
    background-color: white;
    flex-direction: column;
    overflow-x: hidden;
`;

export const widthCss = css`
    display: flex;
    /*width: 1200px;*/
    width: 100%;
    max-width: 1200px;
    padding: 120px 0px;
    flex-direction: column;
    margin: 0 auto;
    gap: 62px;

    .filter {
        display: flex;
        flex-direction: row;
        gap: 6px;
        justify-content: flex-start;
        align-items: flex-start;
        
    }

    
`;

export const modalCss = css`
    width: 621px;
    min-height: 403px;
    flex-direction: column;
    display: inline-flex;
    padding: 40px 26px;
    align-items: flex-start;
    gap: 26px;

    @media (max-width: 640px) {
        width: 341px;
        min-height: 584px;
        flex-direction: column;
    }
    
    .imageCustom {
        width: 268px;
        height: 400px;

        @media (max-width: 640px) {
            width: 241px;
            height: 324px;
            border-radius: 5px;
            margin-left: 30px;
            margin-right: 50px;
            margin-bottom: 10px;
        }
        
    }
  
`;

